<template>
  <v-container class="container" fluid>
    <v-row>
      <v-skeleton-loader
        class="mx-auto"
        type="card"
        v-if="loader"
        style="width: 98%"
      ></v-skeleton-loader>
      <div v-if="noData">Žádná nabídka na dnešní den k zobrazení</div>
      <v-col
        v-for="(diet, index) in diets"
        :key="index"
        cols="12"
      >
        <div class="font-poppins-heading"><span style="color: var(--v-darkGreen-base);" class="font-weight-bold text-uppercase">Dnešní nabídka pro:</span><span class="ml-3 font-weight-bold">{{diet.name}}</span></div>
        <v-card
          elevation="0"
          class="rounded-lg font-readex"
        >
          <v-row class="no-gutters">
              <v-card-text>
                <v-row no-gutters>
                  <v-col sm="2" class="d-none d-sm-block dash-foodbg-container rounded-l-lg" style=" border: 1px solid #d5d5d5; border-right: none ">
                    <v-row
                      v-for="(time, index) in timeTypes"
                      :key="index"
                      v-bind:style="leftCol"
                      v-bind:id="index+'-title'"
                    >
                      <v-col class="text-white px-7 py-4 text-uppercase" v-if="diet.itemStrs[index].length">
                        {{time.name}}:
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col xs="12" sm="10" class="rounded-r-lg" style="background-color: #f7ffe8; border: 1px solid #d5d5d5">
                    <v-row
                      v-bind:id="index+'-food'"
                      v-for="(time, index) in timeTypes"
                      :key="index"
                      ref="foods"
                    >
                      <v-col cols="12" class="d-block d-sm-none ml-3 pb-0 text-uppercase font-weight-bold" v-if="diet.itemStrs[index].length">
                        {{time.name}}:
                      </v-col>
                      <v-col class=" px-8 py-4" v-if="diet.itemStrs[index].length">
                        <span v-for="name in diet.itemStrs[index]" :key="name">{{ name }}<br></span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-col cols="12" class="text-end" style="padding-right: 0">
                  <v-btn
                    color="lightGreen"
                    style="color: white !important;"
                    class="rounded-lg btn btn-green-gradient"
                    to="orders"
                  >Objednat</v-btn>
                </v-col>
              </v-card-text>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
      diets: [],
      timeTypes: [],
      leftCol: {},
      loader: true,
      noData: false
    }
  },
  methods: {
    matchHeight () {
      for (let i = 0; i < 6; i++) {
        // console.log(foodHeight)
        document.getElementById(i + '-title').style.height = document.getElementById(i + '-food').clientHeight + 'px'
      }
    },
    initialize () {
      (new Promise((resolve, reject) => {
        let diets
        let timeTypes
        this.$http.get('/overview/diets')
          .then(response => {
            diets = this.keysToCamelCase(response.data)
            if (!response.data.length) {
              this.loader = false
              this.noData = true
            }
            if (timeTypes !== undefined) {
              resolve({
                diets,
                timeTypes
              })
            }
          })
        this.$http.get('/times')
          .then(response => {
            timeTypes = this.keysToCamelCase(response.data)
              .filter(time => time.active)

            if (diets !== undefined) {
              resolve({
                diets,
                timeTypes
              })
            }
          })
      })).then(response => {
        this.timeTypes = response.timeTypes
          .filter(time => time.active)

        this.diets = response.diets
          .map(diet => {
            diet.itemStrs = ['', '', '', '', '', '']
            const day = diet.dietDays.find(day => day.date === new Date().toISOString().slice(0, 10))
            if (!day) {
              return {}
            }

            const times = [[], [], [], [], [], []].map((timeArr, index) => day.dietDayItems.filter(item => item.timeId === index + 1))
            // console.log(times)
            diet.itemStrs = ['', '', '', '', '', '']
              .map((timeIndex, index) => {
                if (times[index].length) {
                  // console.log(times[index])
                  this.loader = false
                  return times[index].map(item => item.eatable.name)
                } else {
                  return ''
                }
              })
            return diet
          })
      })
    },
    orderFromDiet (diet) {
      const shoppingCart = {
        diet: diet,
        dietId: diet.id,
        boarders: [],
        user: null,
        customPackaging: 1,
        deliveryType: 'Osobní odběr',
        paymentTypeId: 1,
        description: null,
        price: null,
        items: {},
        order: false
      }
      localStorage.setItem('shoppingCart', JSON.stringify(shoppingCart))
      this.$router.push({ name: 'user.orders' })
    }
  },
  updated () {
    this.matchHeight()
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>
.dash-foodbg-container{
  background-image: url("../../assets/user-dashboard-foodbg.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.dash-foodbg{
}
</style>
